var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9086 1.42734L20.1987 8.09389C20.4275 8.55755 20.8699 8.87883 21.3816 8.95307L28.7388 10.0222C30.0276 10.2096 30.5417 11.7929 29.6095 12.7013L24.2859 17.8905C23.9159 18.2513 23.7468 18.7716 23.8344 19.2809L25.0909 26.6082C25.3112 27.8915 23.964 28.87 22.8115 28.2645L16.2314 24.8053C15.7738 24.5649 15.2268 24.5649 14.7692 24.8053L8.18906 28.2645C7.03659 28.8706 5.68941 27.8915 5.90968 26.6082L7.1662 19.2809C7.25382 18.7716 7.08466 18.2513 6.71471 17.8905L1.39108 12.7013C0.458883 11.7923 0.973052 10.209 2.26182 10.0222L9.619 8.95307C10.1307 8.87883 10.5731 8.55755 10.8019 8.09389L14.092 1.42734C14.6676 0.259654 16.3324 0.259654 16.9086 1.42734Z",
    fill: "url(#paint0_radial_7_29)",
    stroke: "url(#paint1_angular_7_29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.917 12.5074) rotate(132.769) scale(28.2298 30.6958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04FB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414597,
    stopColor: "#00AE1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_7_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7872 14.5) rotate(-46.3668) scale(19.2719 20.7804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.155c1aeeab90fbc0b307ec17c76445bf.svg";
export { ForwardRef as ReactComponent };